/*global $*/
/*eslint no-undef: "error"*/

export default class AjaxCommercial {
    classButton = 'ajax--commercial'
    classCount = 'ajax--commercial-count'

    constructor () {
        let self = this

        $(`.${self.classButton}`).click(function () {
            const commercialID = parseInt($(this).data('id'))
            const commercialName = $(this).data('name')

            if (location.hostname !== 'localhost') {
                fetch(`/directory/api/v1/like/commercial/${commercialID}/${commercialName}/`)
                    .then(response => response.json())
                    .then(data => {
                        if (data.like && data.url) {
                            $(this).find(`.${self.classCount}`).text(data.like)
                            window.location.href = data.url
                        }
                    })
            } else {
                console.log('ajax like')
            }

            return false
        })
    }
}
